export const educationData = [
    {
        id: 1,
        institution: 'Northeastern University',
        course: 'Masters in Bioinformatics',
        startYear: '2022',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Sreenidhi Institute of Science and Technology',
        course: 'Bachelor of Technology in Biotechnology',
        startYear: '2016',
        endYear: '2020'
    },
]